import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../services/app.service';
import { AuthCodeFormComponentUser } from '../utils/auth-code-form-user/auth-code-form-user.component';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-activate-user',
    imports: [AuthCodeFormComponentUser, ButtonModule],
    templateUrl: './activate-user.component.html',
    styleUrl: './activate-user.component.scss'
})
export class ActivateUserComponent {
  token: string = '';
  client!: number;
  enProceso = false;
  showSuccess = false;
  showResponse = false;
  showOtp = false;
  data:string=''; 

  constructor(private services: AppService, private route: ActivatedRoute,) {
    this.route.queryParamMap.subscribe((params) => {
      this.token = params.get('token') || '';
      this.client = parseInt(params.get('client')!.toString()) || 0;
      this.data= params.get('email') || '';
    });
  }

  ngAfterViewInit(): void {


  }

  sendRequestActivate() {
    this.enProceso = true
    this.services.activateAccount(this.client, this.token, false,"", this.data,2).subscribe({
      next: (data: any) => {

        this.enProceso = false;
        if (data.isSuccess) {

          if (data.message.includes('Mensaje enviado')) {
            this.showOtp = true;
          } else {
            this.showSuccess = true;
            this.showResponse = true;
            this.showOtp = false;
          }


        }
      },
      error: (error: any) => {
        this.showResponse = true;
        this.enProceso = false;
        this.showSuccess = false;

      }
    })
  }

  closeForm(resp: any) {
    this.showOtp = false;
    this.showResponse = true;
    this.showSuccess = resp==undefined?false:resp.success;    
  }

}
